import React, { useMemo } from "react";
import Dropdown from "../DropDown";

interface AvailablePiMetricsDropdownProps {
  piRecords: any[];
  selectedResourceName: string;
  className?: string;
}

const AvailablePiMetricsDropdown: React.FC<AvailablePiMetricsDropdownProps> = ({
  piRecords,
  selectedResourceName,
  className = "",
}) => {
  const options = useMemo(() => {
    if (!selectedResourceName) return [];

    const resourceNameLower = selectedResourceName.toLowerCase();

    return (piRecords || [])
      .filter(
        (r: any) =>
          r.ISO_RESOURCE_NAME &&
          r.ISO_RESOURCE_NAME.toLowerCase() === resourceNameLower
      )
      .map((r: any) => ({
        value: r.PI_METRIC_ID,   
        label: r.METRIC_NAME,    
      }))
      .filter((o) => o.label)    
      .sort((a, b) =>
        a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
      );
  }, [piRecords, selectedResourceName]);

  return (
    <Dropdown
      options={options}
      selectedValue=""
      onValueChange={() => {}}   
      disabled={false}
      className={className}
      placeholder={
        options.length > 0
          ? `Available PI Metrics (${options.length})`
          : "No PI Metrics Available"
      }
    />
  );
};

export default AvailablePiMetricsDropdown;
